import { defineComponent, inject, PropType } from 'vue';
import { IMsg } from '_c/typings/model/im';
import { TextNodeConfig } from '@/business/chat/generate-text-node-config';
import { TextNodeType } from '_c/typings/model/chat';
import { LinkManager } from '_c/business/manager/link';
import { DB } from '_c/typings/model/db';
import TextLinkContent from '@/component/message/text/component/text-link-content/index.vue';
import VideoLinkContent from '@/component/message/text/component/video-link-content/index.vue';
import { LinkResolveEvent } from '_c/typings/event/global';


export default defineComponent({
  name: 'TextMessageView',
  components: {
    TextLinkContent,
    VideoLinkContent,
  },
  props: {
    text: {
      type: String as PropType<string>,
      required: true,
      default: '',
    },
    textNodeConfigList: {
      type: Array as PropType<Array<TextNodeConfig>>,
      required: true,
    },
  },
  setup(): {
    messageData: IMsg
  } {
    return {
      messageData: inject('messageData') as IMsg,
    };
  },
  data(): {
    linkMsgList: Array<DB.ILinkMsgInfo>,
    hasLinkResolveListener: boolean,
    keepTextEllipsis: boolean
  } {
    return {
      linkMsgList: [],
      hasLinkResolveListener: false,
      keepTextEllipsis: false,
    };
  },
  created() {
    this.handleMsgLinkResolve();
  },
  methods: {
    async handleMsgLinkResolve(): Promise<void> {
      const urlTextNodeList = this.textNodeConfigList.filter(item => item.type === TextNodeType.url);
      const urlList = new Set<string>();
      urlTextNodeList.forEach((item) => {
        urlList.add(item.props.text as string);
      });
      if (urlList.size > 0) {
        this.hasLinkResolveListener = true;
        LinkManager.getInstance().addLinkResolveEventListener(this.onLinkResolve);
        this.updateLinkMsgList([...urlList]);
      }
    },
    async onLinkResolve(e: LinkResolveEvent): Promise<undefined> {
      const linkManager = LinkManager.getInstance();
      const { msgContent, linkList, hasResolveFinish } = e;
      if (msgContent !== this.messageData.content) {
        return;
      }

      await this.updateLinkMsgList(linkList);
      if (hasResolveFinish) {
        this.hasLinkResolveListener = false;
        linkManager.removeLinkResolveEventListener(this.onLinkResolve);
      }
    },
    async updateLinkMsgList(linkList: string[]): Promise<void> {
      if (linkList.length === this.linkMsgList.length) {
        return;
      }

      const linkManager = LinkManager.getInstance();
      this.linkMsgList = await linkManager.getLinkMsgList(linkList);
      this.keepTextEllipsis = this.linkMsgList?.[0]?.link === this.messageData.content;
    },
  },
});
